"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toLower = void 0;

/**
 * Convert string to lower case
 *
 * @tag String
 * @signature ( source: string ): string
 *
 * @param   {string}  source  Source string
 *
 * @return  {string}
 *
 * @example
 * toLower("Lorem Ipsum")
 * // "lorem ipsum"
 */
var toLower = function toLower(source) {
  return "".toLowerCase.call(source);
};

exports.toLower = toLower;